var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.303 13.4258C19.777 13.2588 19.215 13.5498 19.047 14.0758C18.11 17.0218 15.352 18.9998 12.184 18.9998C8.222 18.9998 5 15.8598 5 11.9998C5 8.14082 8.222 4.99982 12.184 4.99982C13.912 4.99982 15.542 5.60182 16.829 6.66982L14.663 6.31282C14.113 6.21282 13.603 6.59182 13.513 7.13582C13.423 7.68082 13.792 8.19582 14.337 8.28482L18.583 8.98682C18.638 8.99582 18.694 8.99982 18.747 8.99982C18.866 8.99982 18.982 8.97882 19.09 8.93882C19.127 8.92482 19.157 8.89882 19.193 8.87982C19.259 8.84582 19.328 8.81582 19.385 8.76782C19.421 8.73882 19.444 8.69682 19.475 8.66282C19.522 8.61382 19.572 8.56682 19.607 8.50682C19.632 8.46382 19.642 8.41282 19.661 8.36482C19.685 8.30582 19.717 8.25082 19.729 8.18582L20.483 4.18582C20.585 3.64282 20.228 3.11882 19.685 3.01782C19.144 2.91982 18.619 3.27282 18.517 3.81482L18.245 5.25582C16.581 3.81482 14.448 2.99982 12.184 2.99982C7.12 2.99982 3 7.03682 3 11.9998C3 16.9628 7.12 20.9998 12.184 20.9998C16.226 20.9998 19.75 18.4608 20.953 14.6818C21.12 14.1558 20.829 13.5938 20.303 13.4258Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/Refresh.ff9a86ba9f9fd8a2ed7f4d1cce8166c4.svg";
export { ForwardRef as ReactComponent };